<template>
    <div class="prepend-payment">
        <PublicOfferOrderStickyButton :order="order" :text="accessButtonTitle" background="blue" />

        <!-- Merchants select -->
        <template v-if="severalMerchants">
            <default-title key="title" large class="mt-20 mb-10">
                {{ t("payments.integrations.title") }}:
            </default-title>
            <PublicOfferOrderMerchants
                key="merchantsList"
                :merchants="merchants"
                :selected="selectedMerchant"
                @select="$emit('selectedMerchant:change', $event)"
            />
        </template>

        <PublicOfferAuth
            :order-id="order.id"
            class="mt-20"
            @auth="$emit('handleAuth', $event)"
            v-if="displayOfferAuth"
        />

        <template v-else-if="displayButton">
            <!-- Access button -->
            <DefaultButton
                size="x-large"
                :text="accessButtonTitle"
                :background="'blue'"
                :disabled="severalMerchants ? !selectedMerchant : false"
                class="full-width mt-20"
                @click="handleClick"
            />

            <!-- Terms -->
            <p
                v-html="
                    t('step_start.cabinet_policy', {
                        data_processing_agreement: this.getLink('privacy-policy'),
                        terms_and_conditions: this.getLink('terms-and-conditions')
                    })
                "
                key="terms"
                class="public-offer-terms mt-20"
            ></p>
        </template>
    </div>
</template>

<script>
import DefaultButton from "@components/Buttons/DefaultButton.vue"
import DefaultTitle from "@components/Typography/DefaultTitle.vue"
import PublicOfferAuth from "./PublicOfferAuth.vue"
import PublicOfferOrderMerchants from "./PublicOfferOrderMerchants.vue"
import PublicOfferOrderStickyButton from "./PublicOfferOrderStickyButton.vue"

export default {
    props: {
        order: {
            type: Object,
            default: () => {}
        },
        selectedMerchant: {
            type: Object,
            default: null
        },
        auth: {
            type: Boolean,
            default: false
        },
        severalMerchants: {
            type: Boolean,
            default: false
        },
        merchants: {
            type: Array,
            default: null
        }
    },
    name: "PublicOfferPrependPayment",
    components: {
        PublicOfferOrderStickyButton,
        PublicOfferAuth,
        PublicOfferOrderMerchants,
        DefaultButton,
        DefaultTitle
    },
    data() {
        return {
            showAuth: false
        }
    },
    created() {
        if (!this.severalMerchants && this.merchants.length) {
            this.$emit("selectedMerchant:change", this.merchants[0])
        }
    },
    methods: {
        handleClick() {
            if (this.auth) {
                this.$emit("handlePaymentLinks")
            } else if (this.selectedMerchant?.is_pay_without_registration) {
                this.$emit("handlePaymentLinks")
            } else {
                this.showAuth = true
            }
        },
        getLink(path) {
            return `${window.app_url}${path}`
        }
    },
    computed: {
        accessButtonTitle() {
            if (
                (this.order.fields && this.order.unfilled) ||
                (!this.auth &&
                    this.severalMerchants &&
                    this.selectedMerchant &&
                    !this.selectedMerchant?.is_pay_without_registration)
            ) {
                return this.t("expert.next")
            } else {
                return this.t("payments.pay")
            }
        },
        displayButton() {
            return this.order.payment_links.length || !this.auth
        },
        displayOfferAuth() {
            return this.showAuth && !this.auth && !this.selectedMerchant?.is_pay_without_registration
        }
    }
}
</script>

<style scoped lang="sass">

</style>
